export default __webpack_public_path__ + "static/media/fd7e615012a7bc465cf25965f57de106.png";